function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => func == null ? acc : function(...args) {
    acc.apply(this, args), func.apply(this, args);
  }, () => {
  });
}
export {
  createChainedFunction as default
};
//# sourceMappingURL=createChainedFunction.js.map
